var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBellNav = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13 4.056V2h-2v2.078c-.998.153-2.135.549-3.125 1.341C6.491 6.527 5.5 8.326 5.5 11v4.52l-2.125 1.7L4 19h16l.625-1.78-2.125-1.7V11c0-1.083-.184-2.8-1.1-4.277-.84-1.353-2.24-2.417-4.4-2.667M7.5 11c0-2.126.76-3.327 1.625-4.02C10.032 6.256 11.169 6 12 6c2.063 0 3.112.829 3.7 1.777.634 1.023.8 2.307.8 3.223v5a1 1 0 0 0 .375.78l.274.22H6.851l.274-.22A1 1 0 0 0 7.5 16zM12 23a2.5 2.5 0 0 0 2.5-2.5h-5A2.5 2.5 0 0 0 12 23",
    clipRule: "evenodd"
  })));
};
export default SvgBellNav;